import { createClient } from '@supabase/supabase-js';

const URL = process.env.REACT_APP_SUPABASE_URL;
const ANON = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!URL || !ANON) {
  // eslint-disable-next-line no-console
  console.warn('[Supabase] Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY');
}

export const supabase = createClient(URL, ANON, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storageKey: 'cashdeck-auth',
  },
});

// Helper — friendly Slovak error message from supabase error
export function sbError(err) {
  if (!err) return '';
  const m = err.message || String(err);
  if (m.includes('schema cache') || m.includes('does not exist')) {
    return 'Databázová schéma ešte nie je nastavená. Spusti supabase_schema.sql v Supabase SQL Editori.';
  }
  if (m.includes('JWT') || m.includes('token')) return 'Sedenie vypršalo. Prihlás sa znova.';
  if (m.includes('row-level security') || m.includes('RLS')) return 'Nemáš oprávnenie na túto akciu.';
  if (m.includes('duplicate key')) return 'Tento záznam už existuje.';
  return m;
}
